import MembersOnlyBadge from './MembersOnlyBadge';

export default MembersOnlyBadge;
